import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

class StripeConnectService {
  async createConnectAccountLink({ tenantId, userId, email, companyName, returnUrl, refreshUrl }) {
    if (!tenantId || !userId || !email) {
      throw new Error('tenantId, userId, and email are required to create Stripe Connect account link');
    }

    const connectAccountLink = httpsCallable(functions, 'createStripeConnectAccountLink');
    const response = await connectAccountLink({
      tenantId,
      userId,
      email,
      companyName,
      returnUrl,
      refreshUrl
    });

    if (!response?.data?.success) {
      throw new Error(response?.data?.error || 'Unable to create Stripe Connect account link');
    }

    return response.data;
  }

  async getStripeConnectAccountStatus({ userId }) {
    if (!userId) {
      throw new Error('userId is required to get Stripe Connect account status');
    }

    const getStatus = httpsCallable(functions, 'getStripeConnectAccountStatus');
    const response = await getStatus({ userId });

    if (!response?.data?.success) {
      throw new Error(response?.data?.error || 'Unable to retrieve Stripe Connect account status');
    }

    return response.data;
  }

  async createPartnerCheckoutSession({ partnerTenantId, customerEmail, lineItems, successUrl, cancelUrl, metadata = {} }) {
    if (!partnerTenantId || !lineItems || !successUrl || !cancelUrl) {
      throw new Error('partnerTenantId, lineItems, successUrl, and cancelUrl are required');
    }

    const createSession = httpsCallable(functions, 'createStripeCheckoutSession');
    const response = await createSession({
      partnerTenantId,
      customerEmail,
      lineItems,
      successUrl,
      cancelUrl,
      metadata
    });

    if (!response?.data?.success) {
      throw new Error(response?.data?.error || 'Unable to create Stripe checkout session');
    }

    return response.data;
  }
}

export const stripeConnectService = new StripeConnectService();
export default stripeConnectService;
